import React from 'react';

// PIN inputs deliberately do not use type="password" because Chrome offers
// to save every type="password" field as a credential, and on this app it
// even overwrites the saved login password entry with the PIN. We render
// as type="text" with CSS masking instead, so the value is hidden on
// screen but the browser sees a plain text field and offers no save
// prompt. autoComplete="one-time-code" adds a second signal that this is
// not a credential worth remembering.
const PIN_MASK_STYLE = {
    WebkitTextSecurity: 'disc',
    MozTextSecurity: 'disc',
    textSecurity: 'disc',
};

const PinInput = React.forwardRef(({ className = 'form-control', style, ...inputProps }, ref) => (
    <input
        inputMode="numeric"
        autoComplete="one-time-code"
        {...inputProps}
        ref={ref}
        type="text"
        className={className}
        style={{ ...PIN_MASK_STYLE, ...style }}
    />
));

export default PinInput;
